import httpClient from './httpClient';

const API_BASE = '/api';

const toolCostService = {
  async matchTemplate(params) {
    const response = await httpClient.get(`${API_BASE}/process-templates/match-for-cost`, {
      params,
    });
    return response.data;
  },

  async getAvailableTemplates(params) {
    const response = await httpClient.get(`${API_BASE}/tool-cost-calculator/available-templates`, {
      params,
    });
    return response.data;
  },

  async getAvailableBarStocks(params) {
    const response = await httpClient.get(`${API_BASE}/tool-cost-calculator/available-bar-stocks`, {
      params,
    });
    return response.data;
  },

  async calculateCost(data) {
    const response = await httpClient.post(`${API_BASE}/tool-cost-calculator/calculate`, data);
    return response.data;
  },

  async getCalculationHistory() {
    const response = await httpClient.get(`${API_BASE}/tool-cost-calculator/history`);
    return response.data;
  },
};

export default toolCostService;
